/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_LegalInputs */

const cs_enum_legal = /** @type {(inputs: Enum_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Právní`)
};

const en_enum_legal = /** @type {(inputs: Enum_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

/**
* | output |
* | --- |
* | "Legal" |
*
* @param {Enum_LegalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_legal = /** @type {((inputs?: Enum_LegalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_LegalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_legal(inputs)
	return cs_enum_legal(inputs)
});